<template>
    <div>
        <b-card :title="__('profile.Update Basic Information')" class="mb-3">
            <update :user="user" :endpoint="endpointUpdate"></update>
        </b-card>

        <b-card :title="__('profile.Update Password')" class="mb-3">
            <update-password :endpoint="endpointUpdatePassword"></update-password>
        </b-card>
    </div>
</template>

<script>
import Update from "./Update";
import UpdatePassword from "./UpdatePassword";

export default {
    components: {
        Update,
        UpdatePassword
    },
    props: ['user', 'endpointUpdate', 'endpointUpdatePassword'],
}
</script>

<style scoped>

</style>
